require('./billing.service');
require('./billing.controller');
require('./status');



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/index.js
// module id = 414
// module chunks = 0